module.exports = ".LedTable{\r\n    width:100%;\r\n}\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/Components/main/main.component.css
 ** module id = 39
 ** module chunks = 0
 **/